import React from 'react'
import { connect } from 'react-redux'
import cleaners from 'lib/field/cleaners'
import { httpPost, wsUrl } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import { rateLimitMessage } from 'lib/rateLimit'
import { Template } from './Template'
import { Socket } from 'phoenix'
import validate from './validate'
import { withRouter } from 'lib/hooks/withRouter'

// ...existing code...

export class Interest extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
      values: {
        amount: '',
        categoryId: 0,
        end_date: '',
        investmentId: 0,
        product: '',
        transaction_date: '',
        start_date: '',
      },
      allocationResult: null,
    }
    this.socket = null
    this.channel = null
  }
  connectToChannel = () => {
    const { dispatch, email } = this.props
    this.socket = new Socket(wsUrl(), { params: {} })
    this.socket.connect()
    this.channel = this.socket.channel(`async_task:${email}`)

    this.channel.on('task_complete', ({ allocationResult }) => {
      this.setState({ allocationResult, isSubmitting: false })
      dispatch(setUnload())
      dispatch(setBanner('Allocation successfully created.'))
      this.props.location.navigate('/contacts')
    })

    this.channel.on('task_error', (error) => {
      dispatch(setBanner(`Error creating allocation: ${error}`, 'danger'))
      this.setState({ isSubmitting: false })
      dispatch(setUnload())
    })

    this.channel.join().receive('error', (resp) => {
      dispatch(setBanner('Unable to join Conductor channel', 'danger'))
    })
  }

  buildParams = () => {
    const {
      amount,
      categoryId,
      end_date,
      investmentId,
      start_date,
      transaction_date,
    } = this.state.values
    return {
      amount: cleaners.money(amount),
      category_id: categoryId,
      end_date,
      investment_id: investmentId,
      start_date,
      transaction_date,
    }
  }

  canSubmit = () => {
    const { values } = this.state
    return (
      validate.amount(values.amount) &&
      validate.categoryId(values.categoryId) &&
      validate.dateRange(values.start_date, values.end_date) &&
      validate.investmentId(values.investmentId) &&
      validate.transactionDate(values.transaction_date)
    )
  }

  setDefaultOptions = (product) => {
    let options = [
      { array: product.categories, value_attr: 'categoryId' },
      { array: product.investments, value_attr: 'investmentId' },
    ]
    options.forEach((option) => {
      let value = 0
      if (option?.array?.length >= 1) {
        value = option.array[0].id
      }
      this.setState(({ values }) => ({
        values: { ...values, [option.value_attr]: value },
      }))
    })
  }

  handleProductLoad = (data) => {
    this.setState(({ values }) => ({
      values: { ...values, product: data.product },
    }))
    this.setDefaultOptions(data.product)
  }

  handleChange = (event) => {
    const { name, value } = event.target
      ? event.target
      : {
          name: event.name,
          value: event?.value?.value
            ? event.value.value
            : event?.value
            ? event.value
            : '',
        }
    this.setState(({ values }) => ({ values: { ...values, [name]: value } }))
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { dispatch } = this.props
    this.setState({ isSubmitting: true, allocationResult: null })
    dispatch(setLoad())
    httpPost('/admin/allocations', this.buildParams())
  }

  updateAmount = (updater) => {
    const { values } = this.state
    const newValues = { ...values, amount: updater(values.amount) }
    this.setState({ values: newValues })
  }

  componentDidMount() {
    this.connectToChannel()
  }

  render() {
    return (
      <Template
        canSubmit={!this.state.isSubmitting && this.canSubmit()}
        dispatch={this.dispatch}
        onChange={this.handleChange}
        onProductLoad={this.handleProductLoad}
        onSubmit={this.handleSubmit}
        updateAmount={this.updateAmount}
        values={this.state.values}
        allocationResult={this.state.allocationResult}
      />
    )
  }
}

import { createStructuredSelector } from 'reselect'
import { email } from 'lib/user/selectors'

export default withRouter(connect(
  createStructuredSelector({ email })
)(Interest))
